import { render } from "./Metas.vue?vue&type=template&id=8b1b4180"
import script from "./Metas.vue?vue&type=script&lang=js"
export * from "./Metas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__